interface DiscordUploadResponse {
  success: boolean;
  url?: string;
  error?: string;
}

export async function uploadToDiscord(imageUrl: string, filename: string): Promise<DiscordUploadResponse> {
  const webhookUrl = import.meta.env.VITE_DCWEBHOOK;
  
  if (!webhookUrl) {
    console.warn('Discord webhook URL not configured');
    return { success: false, error: 'Webhook not configured' };
  }

  try {
    // Convert data URL to blob if needed
    let blob: Blob;
    if (imageUrl.startsWith('data:')) {
      const response = await fetch(imageUrl);
      blob = await response.blob();
    } else {
      const response = await fetch(imageUrl);
      blob = await response.blob();
    }

    // Create FormData for Discord upload
    const formData = new FormData();
    formData.append('file', blob, filename);
    
    // Add a message with the upload
    const payload = {
      content: `🖼️ **Gambar Background Removed**\n📁 **File:** ${filename}\n⏰ **Waktu:** ${new Date().toLocaleString('id-ID')}\n🔗 **Source:** Remove BiJi (BG) App`,
      username: 'BG Remover Bot',
      avatar_url: 'https://cdn.discordapp.com/emojis/🖼️.png'
    };
    
    formData.append('payload_json', JSON.stringify(payload));

    const response = await fetch(webhookUrl, {
      method: 'POST',
      body: formData,
    });

    if (response.ok) {
      return { success: true, url: imageUrl };
    } else {
      const errorText = await response.text();
      console.error('Discord upload failed:', errorText);
      return { success: false, error: `Upload failed: ${response.status}` };
    }
  } catch (error) {
    console.error('Error uploading to Discord:', error);
    return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
  }
}

export async function uploadToDiscordWithNotification(
  imageUrl: string, 
  filename: string,
  onProgress?: (status: string) => void
): Promise<DiscordUploadResponse> {
  onProgress?.('Mempersiapkan upload...');
  
  const result = await uploadToDiscord(imageUrl, filename);
  
  if (result.success) {
    onProgress?.('Upload berhasil! Memulai download...');
  } else {
    onProgress?.(`Upload gagal: ${result.error}`);
  }
  
  return result;
}